(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["chesona-bundle-switch"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('chesona-bundle-switch')) {
    customElements.define('chesona-bundle-switch', class extends HTMLElement {
      connectedCallback() {
        requestAnimationFrame(() => {
          if (!this.isConnected || this.controller) return;

          const source = this.querySelector('[data-switch-data]');
          this.root = this.closest('[data-cloud-x-section]');
          if (!source || !this.root) return;

          this.data = JSON.parse(source.textContent);
          this.controller = new AbortController();

          this.schedule = () => {
            clearTimeout(this.timer);
            this.timer = setTimeout(() => this.update(), 0);
          };

          this.root.addEventListener(
            'change',
            this.schedule,
            { signal: this.controller.signal }
          );

          this.root.addEventListener('click', event => {
            if (event.target.closest('[data-cloud-x-option-button]')) {
              this.schedule();
            }
          }, { signal: this.controller.signal });

          this.addEventListener('click', event => {
            this.update();
            if (event.target.closest('[aria-disabled="true"]')) {
              event.preventDefault();
            }
          }, { signal: this.controller.signal });

          this.update();
        });
      }

      disconnectedCallback() {
        this.controller?.abort();
        this.controller = null;
        clearTimeout(this.timer);
      }

      update() {
        const normal = value => String(value ?? '').trim().toLowerCase();
        const key = value =>
          /colou?r|颜色/.test(normal(value)) ? 'color' : normal(value);

        const chosen = this.data.selected.slice();

        this.root.querySelectorAll('.cloud-x-option-select').forEach(select => {
          chosen[Number(select.dataset.optionPosition) - 1] = select.value;
        });

        const current = this.data.variants.find(variant =>
          variant.options.every((value, i) =>
            normal(value) === normal(chosen[i])
          )
        );

        this.querySelector('[data-current-price]').textContent =
          current?.price || '';

        const other = this.data.other;

        const sourceIndexes = other.options.map(name =>
          this.data.options.findIndex(source => key(source) === key(name))
        );

        const matches = other.variants.filter(variant =>
          variant.options.every((value, i) => {
            const index = sourceIndexes[i];

            if (index >= 0) {
              return normal(value) === normal(chosen[index]);
            }

            return new Set(
              other.variants.map(item => normal(item.options[i]))
            ).size === 1;
          })
        );

        const target =
          matches.find(variant => variant.available) || matches[0];

        const link = this.querySelector('[data-other-link]');
        const enabled = Boolean(current && target?.available);

        this.querySelector('[data-other-price]').textContent =
          target?.price || '';

        this.querySelector('[data-other-status]').textContent =
          !current || !target
            ? this.data.unavailable
            : target.available ? '' : this.data.soldOut;

        link.setAttribute('aria-disabled', String(!enabled));

        if (enabled) {
          const url = new URL(other.url, location.origin);
          url.searchParams.set('variant', target.id);
          link.href = url.pathname + url.search;
          link.removeAttribute('tabindex');
        } else {
          link.removeAttribute('href');
          link.setAttribute('tabindex', '-1');
        }
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
